import { SVGProps } from 'react';

export const DepthIllustration = ({
  orientation,
  size,
  ...props
}: SVGProps<SVGSVGElement> & {
  orientation: 'topLeft' | 'bottomRight';
  size?: number;
}) =>
  orientation === 'topLeft' ? (
    <svg
      width={size ?? '491'}
      // Maintaining the image ratio
      // eslint-disable-next-line no-magic-numbers
      height={size && (size * 1.0713).toString()}
      viewBox="0 0 491 526"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M478.844 0C466.421 33.2433 443.636 70.5375 406.713 93.5942C381.943 109.061 358.578 120.401 336.943 130.901C296.887 150.342 262.759 166.905 236.629 201.456C219.003 224.762 212.764 252.021 205.666 283.034C196.558 322.83 186.036 368.806 148.224 420.535C119.279 460.134 54.1934 495.072 0 513.952V0H478.844Z"
        fill="#F5F6F7"
      />
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M399.374 0C394.543 6.27327 389.238 12.5171 383.415 18.6944C345.491 58.9317 293.954 72.0607 246.006 84.2759C197.015 96.7567 151.769 108.283 128.613 146.797C79.9579 227.724 37.1313 270.866 0 292.349L0 0H399.374Z"
        fill="#DDE3E8"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M300.572 0C290.08 7.8571 278.95 14.2487 267.469 18.227C240.899 27.4339 210.99 28.4881 182.789 29.4821C147.295 30.7332 114.507 31.8888 94.4843 49.0838C82.2105 59.6243 76.1944 82.9852 69.3627 109.513C58.3225 152.383 45.1523 203.524 0 222.196V0H300.572Z"
        fill="#DDE3E8"
      />
    </svg>
  ) : (
    <svg
      width={size ?? '391'}
      // Maintaining the image ratio
      // eslint-disable-next-line no-magic-numbers
      height={size && (size * 1.634).toString()}
      viewBox="0 0 391 639"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 638.994C24.892 605.124 41.0937 568.421 63.8268 542.625C83.1722 520.674 104.36 505.328 124.595 490.672C156.667 467.444 186.347 445.947 202.516 402.627C214.734 369.892 214.882 341.838 215.034 312.783C215.211 279.127 215.395 244.128 234.354 198.954C249.639 162.534 283.068 129.214 316.077 96.3114C345.957 66.5289 375.493 37.0884 390.92 6.00024V638.994H15Z"
        fill="#F5F6F7"
      />
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M390.798 180.389V638.995H96C129.75 555.613 187.006 530.839 232.562 511.128C266.444 496.468 293.854 484.608 300.31 453.52C306.845 422.048 307.412 398.086 307.968 374.549C308.703 343.512 309.419 313.212 323.78 267.403C336.139 227.982 360.291 206.97 383.136 187.095C385.713 184.854 388.273 182.626 390.798 180.389Z"
        fill="#DDE3E8"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M390.999 302.893V638.994H202.847C208.047 627.992 214.177 617.733 221.333 608.85C243.572 581.241 267.936 574.826 289.841 569.059C310.663 563.577 329.262 558.681 341.698 536.722C350.64 520.935 352.043 490.872 353.648 456.483C356.125 403.396 359.084 339.998 390.999 302.893Z"
        fill="#DDE3E8"
      />
    </svg>
  );
